<mat-form-field [appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <mat-select
    [value]="values"
    (selectionChange)="onSelectionChange($event.value)"
    [required]="required"
    [disabled]="disabled"
    multiple
  >
    <mat-select-trigger>
      @if (values && values.length > 0) {
        <div>
          <span>{{ values.length }} sélectionné(s)</span>
        </div>
      }
    </mat-select-trigger>
    @for (contractStatus of ContractStatuses; track $index) {
      <mat-option [value]="contractStatus">
        <div>
          <span>{{ contractStatus | contractStatusLabel }}</span>
        </div>
      </mat-option>
    }
  </mat-select>
</mat-form-field>
